<template>
    <div id="chatWindow" v-if="isChatOpened">
        <loading-animation/>
        <div class="header" ref="header">
            <div v-if='chatWindowStatus==1' v-html="currentContent.header"></div>
            <div v-else-if='chatWindowStatus==2 || chatWindowStatus==4' class="d-flex">
                <div @click="closeChat()" class="header-back"><i class="icon-cross"></i></div>
                <div v-html="currentContent.header"></div>
            </div>
            <div v-else-if='chatWindowStatus==3' class="d-flex">
                <div @click="closeChat()" class="header-back"><i class="icon-cross"></i></div>
                <div v-html="currentContent.header"></div>
            </div>
        </div>
        <div class="content" ref="content" v-prevent-parent-scroll :style="{'bottom':footerHeight+'px', 'top': headerHeight+'px'}">
            <div v-if="chatWindowStatus==1 || chatWindowStatus==2">
                <waiting-message
                    v-for="content in currentContent.messages"
                    v-bind:key="content.id"
                    v-bind:message="content">
                </waiting-message>
            </div>
            <div v-else-if="chatWindowStatus==3">
                <send-message :messages="messages"></send-message>
            </div>
            <div v-else-if="chatWindowStatus==4">
                <div v-for="message in currentContent.messages">
                    <offline-message-form :label="message.label" :desc="message.desc">
                    </offline-message-form>
                </div>
            </div>
        </div>
        <div v-if="chatWindowStatus==3 && threadState != 'closed'" class="footer" ref="footer" :class="{'has_cart_share' : shareCartAvailable}">

            <!-- <div class="action-icon file" @click="$refs.fileInput.click()"></div>
             <input
               type="file"
               id="uploadmyfile"
               accept=".txt, .doc, .pdf"
               multiple="multiple"
               @change="onFileSelected"
               ref="fileInput">
             <div class="action-icon image" @click="$refs.imageInput.click()"></div>
             <input
               type="file"
               id="uploadmyImage"
               accept="image/*"
               multiple="multiple"
               @change="onFileSelected"
               ref="imageInput"
               >-->
            <pre v-html="message"></pre>
            <textarea v-model="message" @keyup.enter="getMessage" @keydown.enter="enterKeyDown"/>
            <div v-if="shareCartAvailable" class="action-icon cart" @click="shareCart"></div>
            <div class="action-icon send" @click="getMessage"></div>
        </div>
        <vue-confirm-dialog id="ChatVueDialog">
        </vue-confirm-dialog>
    </div>
</template>

<script>
import WaitingMessage from './WaitingMessage.vue'
import SendMessage from './SendMessage.vue'
import OfflineMessageForm from "./OfflineMessageForm";

import {mapState, mapMutations, mapActions, mapGetters} from 'vuex'
import LoadingAnimation from "@/components/LoadingAnimation";

export default {
    name: 'ChatWindow',
    components: {
      LoadingAnimation,
        WaitingMessage,
        SendMessage,
        OfflineMessageForm
    },
    data() {
        return {
            message: '',
            selectedFile: null,
            imageFile: null,
            headerHeight: 0,
            footerHeight: 0,
        }
    },
    mounted(){
        this.calculateHeights();
    },
    updated() {
        this.$nextTick(() => {this.calculateHeights()});
        if (this.chatWindowStatus!=4){
            this.scrollToEnd();
        }
    },
    methods: {
        ...mapMutations(['changeChatWindowStatus', 'incrementUserMessagesCount']),
        ...mapActions(['sendUserMessage', 'closeCurrentChat', 'shareCartWithAgent']),
        getMessage(event) {
            if (event.shiftKey===true && event.key === "Enter") {
                return;
            }

            if (this.message.length > 0) {
                this.sendUserMessage(this.message);
                this.message = "";
            }
        },
        enterKeyDown(event){
            if (event.key === "Enter" && !event.shiftKey){
                event.preventDefault();
            }
        },
        onFileSelected(event) {
            this.selectedFile = event.target.files[0];
            // EXEC onUpload
            console.log(this.selectedFile);
        },
        onUpload() {
            const fd = new FormData();
            fd.append('file', this.selectedFile.name);
            // API uploadFile
            console.log(fd);
        },
        scrollToEnd() {
            var container = this.$refs['content']
            if (container != undefined){
                var scrollHeight = container.scrollHeight;
                container.scrollTop = scrollHeight;
            }
        },
        shareCart(){
            this.shareCartWithAgent(this.cartInfo);
        },
        closeChat() {
            if(this.threadState == 'closed'){
                this.closeCurrentChat();
                return;
            }
            this.$confirm(
                {
                    message: this.$gettext(`¿Estás seguro que deseas abandonar este chat?`),
                    button: {
                        no: this.$gettext('No'),
                        yes: this.$gettext('Sí')
                    },
                    callback: confirm => {
                        if (confirm) {
                            this.closeCurrentChat();
                            this.message = "";
                        }
                    }
                }
            )
        },
        calculateHeights(){
          if(this.$refs['footer'] != undefined) {
            this.footerHeight = this.$refs['footer'].offsetHeight;
          }else{
            this.footerHeight = 0;
          }
          if(this.$refs['header'] != undefined) {
            this.headerHeight = this.$refs['header'].offsetHeight;
          }else{
            this.headerHeight = 0;
          }
        }
    },
    computed: {
        ...mapState(['isChatOpened', 'chatWindowStatus', 'chatWindowStatuses', 'user', 'chatTypes', 'chatType', 'waitingList', 'messages', 'agentMessagesCount', 'userMessagesCount']),
        ...mapGetters(['messages', 'isUserLogged', 'chatWindowStatusType','threadState','shareCartAvailable','cartInfo']),
        currentContent() {

            var content = {};
            switch (this.chatWindowStatusType) {
                case 'initial':
                    content = {
                        id: 1,
                        header: this.isUserLogged ?
                            this.$gettextInterpolate(this.$gettext('Hej <div class="bold display-3"> %{ user } !</div> para una atención mas especializada, selecciona la temática sobre la que trata tu consulta'), {user: this.user.name}) :
                            this.$gettextInterpolate(this.$gettext('<div class="bold display-3">Hej !</div> para una atención mas especializada, selecciona la temática sobre la que trata tu consulta')),
                        messages: [
                            {
                                id: 1,
                                icon: null,
                                label: this.$gettext('Chatea según la temática de tu consulta'),
                                descClass: 'link-color',
                                type: 'initialmessage',
                                desc: this.chatTypes
                            }
                        ]
                    };
                    break;
                case 'waiting':
                    var waiting_message = this.$gettextInterpolate(this.$gettext('En breve serás atendido, hay %{ n } personas delante tuyo.'), {n: this.waitingList});
                    if (this.waitingList == 0) {
                        waiting_message = this.$gettextInterpolate(this.$gettext('En breve serás atendido'));
                    } else if (this.waitingList == 1) {
                        waiting_message = this.$gettextInterpolate(this.$gettext('En breve serás atendido, hay %{ n } persona delante tuyo.'), {n: this.waitingList});
                    }
                    content = {
                        id: 2,
                        header: this.isUserLogged ?
                            this.$gettextInterpolate(this.$gettext('Hej <div class="bold display-3">%{ user } !</div> uno de nuestros agentes atenderá tu consulta sobre %{ type }'), {
                                user: this.user.name,
                                type: this.currentType.text
                            }) :
                            this.$gettextInterpolate(this.$gettext('<div class="bold display-3">Hej !</div> uno de nuestros agentes atenderá tu consulta sobre %{ type }'), {type: this.currentType.text}),
                        messages: [
                            {
                                id: 1,
                                icon: 'icon-clock main-color',
                                label: this.$gettext('Estás en la cola de espera'),
                                descClass: 'link-color',
                                type: 'message',
                                desc: waiting_message
                            },
                            //{ id: 2, icon: 'icon-phone main-color', label: this.$gettext('O si lo prefieres, nosotros te llamamos'), descClass: null, type:'action', desc: null },
                            //{ id: 3, icon:'icon-whatsapp whatsapp-color', label: this.$gettext('También puedes conversar con un agente vía Whatsapp escribiendo al <span class="bold"><a href="https://api.whatsapp.com/send?phone=0034686966466">686 966 466</a></span>'), descClass: null, type:'message', desc: null }
                        ]
                    };
                    break;
                case 'active':
                    content = {
                        id: 3,
                        header: '<div class="bold">' + this.currentType.text + '</div><div class="small">' + this.currentType.personalMessage + '</div>',
                        messages: [
                            {
                                // aqui van los mensajes
                            }
                        ]
                    };
                    break;
                case 'inactive_group':
                    content = {
                        id: 4,
                        header: this.isUserLogged ?
                            this.$gettextInterpolate(this.$gettext('Hej <div class="bold display-3">%{ user } !</div> Actualmente no hay agentes disponibles.'), {user: this.user.name}) :
                            this.$gettextInterpolate(this.$gettext('<div class="bold display-3">Hej !</div> Actualmente no hay agentes disponibles.')),
                        messages: [
                            {
                                id: 1,
                                label: this.$gettext('Déjanos tu consulta y nosotros nos pondremos en contacto contigo.'),
                                descClass: null,
                                type: 'offline_message',
                                desc: null
                            },
                        ]
                    };
                    break;
            }

            return content;

        },
        currentType() {
            return this.chatTypes[this.chatType];
        }
    },
    watch: {
        "message": function (value) {
          /*if (value.length > 0) {
              this.user.isWritting = true;
          } else {
              this.user.isWritting = false;
          }*/
        }
    }
}
</script>